<template>
  
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">




    <feather-icon
    v-if="$route.name == 'core-fields' && abilities.can('read', 'core-fields')"
      icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToCoreFieldView"
    />
    <feather-icon
    v-if="$route.name == 'core-fields' && abilities.can('update', 'core-fields')"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToCoreFieldEdit"
    />
    <feather-icon
      v-if="$route.name == 'core-fields' && abilities.can('delete', 'core-fields')"
      icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToCoreFieldDelete"
    />
    <feather-icon
    v-if="$route.name == 'manage-client-default-opportunities'"
    icon="Trash2Icon"
    svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
    @click="goToDefaultOpportuntiesViewDelete"
  />
  <feather-icon
  v-if="$route.name == 'manage-client-default-opportunities'"
    icon="EyeIcon"
    svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
    @click="goToDefaultOpportunitiesViewDetails"
  />
  <feather-icon
  v-if="$route.name == 'manage-client-default-opportunities'"
    icon="EditIcon"
    svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
    @click="goToEditDefaulOpportunitiesView"
  />
    <feather-icon
    v-if="$route.name == 'client-user-select-default-views'"
    icon="Trash2Icon"
    svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
    @click="goToDefaultViewDelete"
  />
  <feather-icon
  v-if="$route.name == 'client-user-select-default-views'"
    icon="EyeIcon"
    svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
    @click="goToDefaultViewDetails"
  />
  <feather-icon
  v-if="$route.name == 'client-user-select-default-views'"
    icon="EditIcon"
    svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
    @click="goToEditDefaultView"
  />
    <feather-icon
      v-if="$route.name == 'image-upload'"
      icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToImageDelete"
    />
    <feather-icon
    v-if="$route.name == 'purchase-orders' && abilities.can('read', 'campaign-fields')"
      icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToPurchaseOrderView"
    />
    <feather-icon
    v-if="$route.name == 'purchase-orders' && abilities.can('update', 'campaign-fields')"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToPurchaseOrderEdit"
    />
    <feather-icon
      v-if="$route.name == 'purchase-orders' && abilities.can('delete', 'campaign-fields')"
      icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToPurchaseOrderDelete"
    />
    <feather-icon
    v-if="$route.name == 'opportunity-fields' && abilities.can('read', 'campaign-fields')"
      icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToOpportunityFieldView"
    />
    <feather-icon
    v-if="$route.name == 'opportunity-fields' && abilities.can('update', 'campaign-fields')"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToOpportunityFieldEdit"
    />
    <feather-icon
      v-if="$route.name == 'opportunity-fields' && abilities.can('delete', 'campaign-fields')"
      icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToOpportunityFieldDelete"
    />
    <feather-icon
 v-if="
 $route.name == 'sales-developer-opportunities' || $route.name == 'views-sd-campaign-view-opportunities'"
 icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToEditSalesDeveloperOpportunities"
    />

    <feather-icon
    v-if="
    $route.name =='client-opportunities'"
    icon="EyeIcon"
         svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
         @click="goToViewClientOpportunities"
       />
    <feather-icon
 v-if="
        $route.name == 'accounts'"
              icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToViewAccount"
    />
    <feather-icon
 v-if="
        $route.name == 'accounts'"
              icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToEditAccount"
    />
    <feather-icon
 v-if="
        $route.name == 'accounts'"
              icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="deleteAccount"
    />
 

    <feather-icon
v-if="
       $route.name == 'send-opportunity-alerts'"
             icon="FilePlusIcon"
     svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
     @click="createOpportunityDocsFile"
   />
   <feather-icon
v-if="
       $route.name == 'send-opportunity-alerts'"
             icon="EditIcon"
     svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
     @click="editClientViewDetails"
   />
   <feather-icon
v-if="
       $route.name == 'send-opportunity-alerts'"
             icon="MailIcon"
     svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
     @click="emailOpportunityAlert"
   />
    <feather-icon
v-if="
       $route.name == 'read-email-template' && abilities.can('read', 'email-template')"
             icon="EyeIcon"
     svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
     @click="goToViewEmailTemplate"
   />
<feather-icon
v-if="
       $route.name == 'read-email-template' && abilities.can('update', 'email-template')"
             icon="EditIcon"
     svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
     @click="goToEditEmailTemplate"
   />
    <feather-icon
v-if="
       $route.name == 'read-email-template' && abilities.can('delete', 'email-template')"
             icon="Trash2Icon"
     svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
     @click="goToDeleteEmailTemplate"
   />
    <feather-icon
 v-if="
        $route.name == 'read-docs-template' && abilities.can('read', 'docs-template')"
              icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToViewDocsTemplate"
    />
 <feather-icon
 v-if="
        $route.name == 'read-docs-template' && abilities.can('update', 'docs-template')"
              icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToEditDocsTemplate"
    />
     <feather-icon
 v-if="
        $route.name == 'read-docs-template' && abilities.can('delete', 'docs-template')"
              icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToDeleteDocsTemplate"
    />
    <feather-icon
 v-if="
        $route.name == 'campaign-grade-category' && abilities.can('read', 'categorize-grades')"
              icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToViewGradeCategory"
    />
 <feather-icon
 v-if="
        $route.name == 'campaign-grade-category' && abilities.can('update', 'categorize-grades')"
              icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToEditGradeCategory"
    />
     <feather-icon
 v-if="
        $route.name == 'campaign-grade-category' && abilities.can('delete', 'categorize-grades')"
              icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToDeleteGradeCategory"
    />
    <feather-icon
      v-if="
        $route.name == 'client-dashboard-select-default-views' || $route.name == 'client-campaign-view-select-default-views'"
      icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="viewClientUserRecords"
    />
    <feather-icon
 v-if="
        $route.name == 'client-dashboard-campaign-lists'"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      icon="CornerUpRightIcon"
      @click="goToClientUserDefaultViews"
    />
    <feather-icon
    v-if="
           $route.name == 'client-dashboard-client-default-view-for-opportunities'"
         svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
         icon="CornerUpRightIcon"
         @click="goToClientUserDefaultViewsOpportunities"
       />
     <feather-icon
 v-if="
        $route.name == 'quality-control-accounts'"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      icon="EditIcon"
      @click="goToQualityControlAccounts"
    />
     <feather-icon
 v-if="
        $route.name == 'quality-control-contacts'"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      icon="EditIcon"
      @click="goToQualityControlAccounts"
    />
    <feather-icon
 v-if="
        $route.name == 'quality-control-campaigns'"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      icon="HomeIcon"
      @click="goToQualityControlAccounts"
    />
      <feather-icon
 v-if="
        $route.name == 'quality-control-campaigns'"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      icon="UsersIcon"
      @click="goToQualityControlContacts"
    />
        <feather-icon
 v-if="
        $route.name == 'sales-developer-dashboard' || $route.name == 'sales-developer-dashboard-view' || $route.name == 'views-sd-campaign-view'"
              icon="CheckCircleIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="showStatusPopUp"
    />
    <feather-icon
 v-if="
        $route.name == 'sales-developer-dashboard' || $route.name == 'sales-developer-dashboard-view' || $route.name == 'views-sd-campaign-view'"
              icon="TagIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="showTagPopUp"
    />
    <feather-icon
 v-if="
        $route.name == 'tags'"
              icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToTag"
    />
 <feather-icon
 v-if="
        $route.name == 'tags'"
              icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="editTag"
    />
     <feather-icon
 v-if="
        $route.name == 'tags'"
              icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToTagDelete"
    />
     <feather-icon
 v-if="
        $route.name == 'grade-steps' && abilities.can('read', 'grade-steps')" 
              icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToGradeStep"
    />
 <feather-icon
 v-if="
        $route.name == 'grade-steps' && abilities.can('update', 'grade-steps')" 
              icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="editGradeStep"
    />
     <feather-icon
 v-if="
        $route.name == 'grade-steps' && abilities.can('delete', 'grade-steps')" 
              icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToGradeStepDelete"
    />
      <feather-icon
 v-if="
        ($route.name == 'action-type-outcome-option' || $route.name == 'audit-trial-edit-action-type') && abilities.can('update', 'outcome')"
              icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="editActionTypeOutcomeOption"
    />
     <feather-icon
 v-if="
        ($route.name == 'action-type-outcome-option' || $route.name == 'audit-trial-edit-action-type') && abilities.can('delete', 'outcome')"
              icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToActionTypeOutcomeOptionDelete"
    />
     <feather-icon
      v-if="$route.name == 'grades' && abilities.can('read', 'grade')"
      icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToGrade"
    />
     <feather-icon
     v-if="$route.name == 'grades' && abilities.can('update', 'grade')"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="editGrade"
    />
     <feather-icon
     v-if="$route.name == 'grades' && abilities.can('delete', 'grade')"
      icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToGradeDelete"
    />
       
     <feather-icon
 v-if="
        $route.name == 'audit-trial-read-outcome' && abilities.can('read', 'outcome')"
              icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToCallOutcome"
    />
     <feather-icon
      v-if=" 
        $route.name == 'audit-trial-read-outcome' && abilities.can('update', 'outcome')"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="editCallOutcome"
    />
     <feather-icon
      v-if="$route.name == 'audit-trial-read-outcome' && abilities.can('delete', 'outcome')"
      icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToCallOutcomeDelete"
    />
      <feather-icon
 v-if="
        $route.name == 'audit-trial-read-action-type' && abilities.can('read', 'action-type')"
              icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToCallActionType"
    />
     <feather-icon
      v-if="
        $route.name == 'audit-trial-read-action-type' && abilities.can('update', 'action-type')"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="editCallActionType"
    />
        <feather-icon
        v-if="
        $route.name == 'audit-trial-read-action-type' && abilities.can('delete', 'action-type')"    
          icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToCallActionTypeDelete"
    />
     <feather-icon
      v-if="
        $route.name == 'sales-developer-dashboard' || $route.name == 'sales-developer-dashboard-view' || $route.name == 'views-sd-campaign-view'"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="editSalesDeveloperRecords"
    />
    <feather-icon
      v-if="
        $route.name == 'historic-sales-developer-campaigns'"
      icon="CornerUpRightIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToHistoricSDDashboard"
    />

     <feather-icon
      v-if="
        $route.name == 'live-sales-developer-campaigns'"
      icon="CornerUpRightIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToLiveSDDashboard"
    />
    <feather-icon
    v-if="
      $route.name == 'live-sales-developer-campaigns'"
    icon="SettingsIcon"
    svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
    @click="goToLiveSalesDeveloperDefaultViews"
  />
    <feather-icon
      v-if="
        $route.name == 'populate-sd-data'"
      icon="NavigationIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="openPopulateDataPopUp"
    />
    <feather-icon
      v-if="
        $route.name == 'populate-additional-data' || $route.name == 'refresh-sd-data'"
      icon="NavigationIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="openPopulateDataPopUp"
    />
    <!-- <feather-icon
    v-if="
      $route.name == 'refresh-sd-data'"
    icon="ServerIcon"
    svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
    @click="validatePopulateDataPopUp"
  /> -->
    <feather-icon
      v-if="
        $route.name == 'list-cascade-fields'"
      icon="WindIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="showCampaignCascadedFields"
    />
     <feather-icon
      v-if="
        $route.name == 'list-more-field'"
      icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="showCampaignSelectedFields"
    />
     <feather-icon
      v-if="
        $route.name == 'list-more-field'"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="updateCampaignSelectedFields"
    />



    
    <feather-icon
    id="downloaddownloaddownloaddownloaddownloaddownloaddownloaddownloaddownloaddownload"
    v-if="
      $route.name == 'list-more-field'"
    icon="DownloadIcon"
    svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
  />
    <feather-icon
      v-if="
        $route.name == 'new-selected_accounts-for-campaign' ||
          $route.name == 'add-contacts-to-existing-campaign-accounts'
      "
      icon="PlusIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="addNewContact"
    />
    <feather-icon
      v-if="
        $route.name == 'new-selected_accounts-for-campaign' ||
          $route.name == 'add-contacts-to-existing-campaign-accounts'
      "
      icon="LinkIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="associateContactToSelectedAccountPopup"
    />
    <feather-icon
      v-if="$route.name == 'contacts'"
      icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToContactView"
    />
    <feather-icon
      v-if="$route.name == 'contacts'"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToContactEdit"
    />
    <feather-icon
      v-if="$route.name == 'contacts'"
      icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToContactDelete"
    />
    <feather-icon
      v-if="$route.name == 'add-contacts' || $route.name == 'edit-contacts'"
      icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToContactEmailExistsView"
    />
    <feather-icon
      v-if="$route.name == 'add-contacts' || $route.name == 'edit-contacts'"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToContactEmailExistsEdit"
    />

    <!-- <feather-icon
      v-if="$route.name == 'individually-selected_accounts-for-campaign'"
      icon="LinkIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="associateContactToAccount"
    /> -->

    <feather-icon
      v-if="
           $route.name == 'new-selected_accounts-for-campaign'
      "
      icon="Trash2Icon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click="deleteSelectedAccountForCampaign"
      class="mr-4"
    />

    <feather-icon
    v-if="$route.name == 'master-fields' && abilities.can('read', 'master-fields')"
      icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToMasterFieldView"
    />
    <feather-icon
    v-if="$route.name == 'master-fields' && abilities.can('update', 'master-fields')"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToMasterFieldEdit"
    />
    <feather-icon
      v-if="$route.name == 'master-fields' && abilities.can('delete', 'master-fields')"
      icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToMasterFieldDelete"
    />
     <feather-icon
      v-if="$route.name == 'client-fields' && abilities.can('read', 'client-fields')"
      icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToClientFieldView"
    />
    <feather-icon
    v-if="$route.name == 'client-fields' && abilities.can('update', 'client-fields')"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToClientFieldEdit"
    />
    <feather-icon
    v-if="$route.name == 'client-fields' && abilities.can('delete', 'client-fields')"
      icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToClientFieldDelete"
    />
      <feather-icon
      v-if="$route.name == 'campaign-fields' && abilities.can('read', 'campaign-fields')"
      icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToCampaignFieldView"
    />
    <feather-icon
      v-if="$route.name == 'campaign-fields' && abilities.can('update', 'campaign-fields')"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToCampaignFieldEdit"
    />
    <feather-icon
      v-if="$route.name == 'campaign-fields' && abilities.can('delete', 'campaign-fields')"
      icon="Trash2Icon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="goToCampaignFieldDelete"
    />
     <feather-icon
      v-if="$route.name == 'enhanceaccountmachinelearningRemainder'"
      icon="CheckIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="acceptRemainderAccounts"
    />
    <feather-icon
      v-if="$route.name == 'enhanceaccountmachinelearningRemainder'"
      icon="ZapOffIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="rejectRemainderAccounts"
    />
     <feather-icon
      v-if="$route.name == 'enhancedRejectedAccounts'"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="rejectEnhancedAccounts"
    />


    <feather-icon
    v-if="$route.name == 'unassociated-contacts' && params.node.group"
    icon="PlusIcon"
    svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
    @click="UpdateAssociatedCompanyNameOfContact"
  />

     <!-- <feather-icon
      v-if="$route.name == 'unassociated-contacts' && params.node.group"
      icon="PlusIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="associatedContactWithAccount"
    /> -->

    <feather-icon
    v-if="$route.name == 'unassociated-contacts' && params.node.group"
    icon="ZapOffIcon"
    svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
    @click="dropUnassociatedContacts"
  />



     <!-- <feather-icon
      v-if="$route.name == 'unassociated-contacts'"
      icon="PlusIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="associatedContactWithAccount"
    />
     <feather-icon
      v-if="$route.name == 'unassociated-contacts'"
      icon="ZapOffIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="dropUnassociatedContacts"
    /> -->

    <!-- 
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="deleteSelectedAccountForCampaign" /> -->

    </div>
</template>

<script>
import axios from "@/axios.js";
import defineAbilitiesFor from "@/config/abilities";

export default {
  name: "CellRendererActions",
  data() {
    return {
      selected_account: null,
      abilities: null,

    };
  },
  methods: {
    goToPurchaseOrderView() {
  console.log(this.params.data);
  this.$router.push({
    path: "/campaigns/purchase-order/" + this.params.data.po_id
  });
},
goToPurchaseOrderEdit() {
  this.$router.push({
    path: "/campaigns/purchase-order/edit/" + this.params.data.po_id
  });
},
    goToOpportunityFieldDelete() {
  this.$vs.dialog({
    type: "confirm",
    color: "danger",
    title: `Delete Opportunity Field`,
    accept: this.deleteOpportunityField,
    acceptText: "Delete"
  });
},
deleteOpportunityField() {
  this.$store
    .dispatch(
      "OpportunityFieldsManagement/removeOpportunityField",
      this.params.data.opportunity_field_id
    )
    .then(res => {
      if (res.data.status == "success") {
        this.showOpportunityFieldDeleteSuccess();
      }
    })
    .catch(err => {
      console.error(err);
    });
},
showOpportunityFieldDeleteSuccess() {
   this.$vs.notify({
     color: "success",
     title: "Opportunity Field",
     text: "The Opportunity Field was successfully deleted"
   });
   this.params.api.refreshServerSide({purge:false});
 },
goToPurchaseOrderDelete() {
  this.$vs.dialog({
    type: "confirm",
    color: "danger",
    title: `Delete Purchase Order`,
    accept: this.deletePurchaseOrder,
    acceptText: "Delete"
  });
},
deletePurchaseOrder() {
  this.$store
    .dispatch(
      "PurchaseOrdersManagement/removePurchaseOrder",
      this.params.data.po_id
    )
    .then(res => {
      if (res.data.status == "success") {
        this.showPurchaseOrderDeleteSuccess();
      }
    })
    .catch(err => {
      console.error(err);
    });
},
showPurchaseOrderDeleteSuccess() {
   this.$vs.notify({
     color: "success",
     title: "Purchase Order",
     text: "The Purchase Order was successfully deleted"
   });
   this.params.api.refreshServerSide({purge:false});
 },
 goToImageDelete() {
  this.$vs.dialog({
    type: "confirm",
    color: "danger",
    title: `Delete Image`,
    accept: this.deleteImage,
    acceptText: "Delete"
  });
},
deleteImage() {
   this.$store
     .dispatch(
       "campaignsManagement/deleteImage",
       this.params.data.uuid
     )
     .then(res => {
       if (res.data.status == "success") {
         this.showImageDeleteSuccess();
       }
     })
     .catch(err => {
       console.error(err);
     });
 },
showImageDeleteSuccess() {
   this.$vs.notify({
     color: "success",
     title: "Image",
     text: "The Image was successfully deleted"
   });
   this.params.api.refreshServerSide({purge:false});
 },
 goToDefaultViewDetails() {
  this.$parent.$parent.goToDefaultViewDetails(this.params.data);

},
goToEditDefaultView() {
  this.$parent.$parent.goToEditDefaultView(this.params.data);

},
goToDefaultOpportunitiesViewDetails() {
  this.$parent.$parent.goToDefaultOpportunititesViewDetails(this.params.data);

},
goToEditDefaulOpportunitiesView() {
  this.$parent.$parent.goToEditDefaultOpportunititesView(this.params.data);

},
 goToDefaultViewDelete() {

  this.$vs.dialog({
    type: "confirm",
    color: "danger",
    title: `Delete Default View`,
    accept: this.deleteDefaultView,
    acceptText: "Delete"
  });
},
deleteDefaultView() {
   this.$store
     .dispatch(
       "campaignsManagement/deleteDefaultView",
       this.params.data.uuid
     )
     .then(res => {
       if (res.data.status == "success") {
         this.showDefaultViewDeleteSuccess();
       }
     })
     .catch(err => {
       console.error(err);
     });
 },
 showDefaultViewDeleteSuccess() {
   this.$vs.notify({
     color: "success",
     title: "Default View",
     text: "The Default View was successfully deleted"
   });
   this.params.api.refreshServerSide({purge:false});
 },
 goToDefaultOpportuntiesViewDelete() {

this.$vs.dialog({
  type: "confirm",
  color: "danger",
  title: `Delete Opportunities View`,
  accept: this.deleteDefaultOpportuntiesView,
  acceptText: "Delete"
});
},
deleteDefaultOpportuntiesView() {
 this.$store
   .dispatch(
     "campaignsManagement/deleteDefaultOpportunitiesView",
     this.params.data.uuid
   )
   .then(res => {
     if (res.data.status == "success") {
       this.showDefaultViewOpportuntiesDeleteSuccess();
     }
   })
   .catch(err => {
     console.error(err);
   });
},
showDefaultViewOpportuntiesDeleteSuccess() {
 this.$vs.notify({
   color: "success",
   title: " Opportunities View",
   text: "The Opportunities  View was successfully deleted"
 });
 this.params.api.refreshServerSide({purge:false});
},
    emailOpportunityAlert(){
      this.$parent.$parent.emailOpportunityAlert(this.params.data);

      
      // console.log(this.params.data)
    },
    editClientViewDetails(){
      this.$parent.$parent.editClientViewDetails(this.params.data);
      // console.log(this.params.data)
    },
    createOpportunityDocsFile(){
      this.$parent.$parent.createOpportunityDocsFile(this.params.data);
      // console.log(this.params.data)
    },
    goToViewEmailTemplate() {
   this.$router.push({
     path: "/campaign/view_email_template/" + this.params.data.uuid
   });
 },
 goToEditEmailTemplate(){
  this.$router.push({
   path: "/campaign/edit_email_template/" + this.params.data.uuid
   });
 },
 goToDeleteEmailTemplate() {
   this.$vs.dialog({
     type: "confirm",
     color: "danger",
     title: `Delete Email Template `,
     accept: this.deleteEmailTemplate,
     acceptText: "Delete"
   });
 },
 deleteEmailTemplate() {
   this.$store
     .dispatch(
       "campaignsManagement/deleteEmailTemplate",
       this.params.data.uuid
     )
     .then(res => {
       if (res.data.status == "success") {
         this.showEmailTemplateDeleteSuccess();
       }
     })
     .catch(err => {
       console.error(err);
     });
 },
    goToViewDocsTemplate() {
    // console.log(this.params.data.uuid)
   this.$router.push({
     path: "/campaign/view_docs_template/" + this.params.data.uuid
   });
 },
 goToEditDocsTemplate(){
  this.$router.push({
   path: "/campaign/edit_docs_template/" + this.params.data.uuid
   });
 },
 goToDeleteDocsTemplate() {
   this.$vs.dialog({
     type: "confirm",
     color: "danger",
     title: `Delete Docs Template `,
     accept: this.deleteDocsTemplate,
     acceptText: "Delete"
   });
 },
 deleteDocsTemplate() {
   this.$store
     .dispatch(
       "campaignsManagement/deleteDocsTemplate",
       this.params.data.uuid
     )
     .then(res => {
       if (res.data.status == "success") {
         this.showDocsTemplateDeleteSuccess();
       }
     })
     .catch(err => {
       console.error(err);
     });
 },
 showDocsTemplateDeleteSuccess() {
   this.$vs.notify({
     color: "success",
     title: "Docs Template",
     text: "The Docs Template was successfully deleted"
   });
   this.params.api.refreshServerSide({purge:false});
 },
    goToViewGradeCategory() {
      //  console.log(this.params.data.uuid)
      this.$router.push({
        path: "/campaign/view_grade_category/" + this.params.data.uuid
      });
    },
    goToEditGradeCategory(){
     this.$router.push({
      path: "/campaign/edit_grade_category/" + this.params.data.uuid
      });
    },
    goToDeleteGradeCategory() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Grade Category `,
        accept: this.deleteGradeCategory,
        acceptText: "Delete"
      });
    },
    deleteGradeCategory() {
      this.$store
        .dispatch(
          "campaignsManagement/deleteGradeCategory",
          this.params.data.uuid
        )
        .then(res => {
          if (res.data.status == "success") {
            this.showCategoryDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showCategoryDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Grade Category",
        text: "The Grade Category was successfully deleted"
      });
      this.params.api.refreshServerSide({purge:false});
    },
    goToClientUserDefaultViews() {
      this.$parent.$parent.goToClientUserDefaultViews(this.params.data);
    },
    goToClientUserDefaultViewsOpportunities() {
      this.$parent.$parent.goToClientUserDefaultViewsOpportunities(this.params.data);
    },
    goToQualityControlAccounts() {
      this.$parent.$parent.goToQualityControlAccounts(this.params.data);
    },
    goToQualityControlContacts() {
      this.$parent.$parent.goToQualityControlContacts(this.params.data);
    },
    showStatusPopUp() {
      this.$parent.$parent.showStatusPopUp(this.params.data);
    },
    showTagPopUp() {
      this.$parent.$parent.showTagPopUp(this.params.data);
    },
     goToTag() {
      //  console.log(this.params.data.uuid)
      this.$router.push({
        path: "/tag/view/" + this.params.data.uuid
      });
    },
    editTag(){
     this.$router.push({
        path: "/tag/edit/" + this.params.data.uuid
      });
    },
     goToTagDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Tag `,
        accept: this.deleteTag,
        acceptText: "Delete"
      });
    },
    deleteTag() {
      this.$store
        .dispatch(
          "TagsManagement/removeTag",
          this.params.data.uuid
        )
        .then(res => {
          if (res.data.status == "success") {
            this.showTagDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
      showTagDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Tag  Deleted",
        text: "The tag was successfully deleted"
      });
      this.params.api.refreshServerSide({purge:false});
    },
     editActionTypeOutcomeOption(){
     this.$router.push({
        path: "/audit_trial/action_type_outcome_option/edit/" + this.params.data.uuid
      });
    },
      goToCallActionTypeDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete ActionType`,
        accept: this.deleteActionType,
        acceptText: "Delete"
      });
    },
    deleteActionType() {
      this.$store
        .dispatch(
          "ActionTypesManagement/removeActionType",
          this.params.data.uuid
        )
        .then(res => {
          if (res.data.status == "success") {
            this.showActionTypeDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
      showActionTypeDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "ActionType Field Deleted",
        text: "The action_type was successfully deleted"
      });
      this.params.api.refreshServerSide({purge:false});
    },
    goToCallOutcomeDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Outcome`,
        accept: this.deleteOutcome,
        acceptText: "Delete"
      });
    },
    deleteOutcome() {
      this.$store
        .dispatch(
          "OutcomesManagement/removeOutcome",
          this.params.data.uuid
        )
        .then(res => {
          if (res.data.status == "success") {
            this.showOutcomeDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
      showOutcomeDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Outcome Field Deleted",
        text: "The outcome was successfully deleted"
      });
      this.params.api.refreshServerSide({purge:false});
    },
    goToCallActionType() {
      this.$router.push({
        path: "/audit_trial/action_type/view/" + this.params.data.uuid
      });
    },
    editCallActionType(){
     this.$router.push({
        path: "/audit_trial/action_type/edit/" + this.params.data.uuid
      });
    },
    goToGradeStep() {
      //  console.log(this.params.data.uuid)
      this.$router.push({
        path: "/grade-step/view/" + this.params.data.uuid
      });
    },
    editGradeStep(){
     this.$router.push({
        path: "/grade-step/edit/" + this.params.data.uuid
      });
    },
     goToGradeStepDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Grade Step`,
        accept: this.deleteGradeStep,
        acceptText: "Delete"
      });
    },
    deleteGradeStep() {
      this.$store
        .dispatch(
          "GradesManagement/removeGradeStep",
          this.params.data.uuid
        )
        .then(res => {
          if (res.data.status == "success") {
            this.showGradeStepDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
      showGradeStepDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Grade Step Deleted",
        text: "The grade step was successfully deleted"
      });
      this.params.api.refreshServerSide({purge:false});
    },
     goToGrade() {
       // // console.log(this.params.data.uuid)
      this.$router.push({
        path: "/grade/view/" + this.params.data.uuid
      });
    },
    editGrade(){
     this.$router.push({
        path: "/grade/edit/" + this.params.data.uuid
      });
    },
     goToGradeDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Grade`,
        accept: this.deleteGrade,
        acceptText: "Delete"
      });
    },
    deleteGrade() {
      this.$store
        .dispatch(
          "GradesManagement/removeGrade",
          this.params.data.uuid
        )
        .then(res => {
          if (res.data.status == "success") {
            this.showGradeDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
      showGradeDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Grade Field Deleted",
        text: "The grade was successfully deleted"
      });
      this.params.api.refreshServerSide({purge:false});
    },
    goToCallOutcome() {
      this.$router.push({
        path: "/audit_trial/outcome/view/" + this.params.data.uuid
      });
    },
    editCallOutcome(){
     this.$router.push({
        path: "/audit_trial/outcome/edit/" + this.params.data.uuid
      });
    },
    UpdateAssociatedCompanyNameOfContact() {


      this.$parent.$parent.UpdateAssociatedCompanyNameOfContact(this.params.node.key);
    },
    associatedContactWithAccount() {

console.log(this.params.node.group);


this.$parent.$parent.associatedContactWithAccount(this.params.data);
},
    dropUnassociatedContacts() {
      // alert("dropUnassociatedContacts");
      // console.log(this.params);

      if (this.params.node.group) {
        this.$parent.$parent.dropUnassociatedContactsWithGroup(this.params.node.key);

      }else{
        this.$parent.$parent.dropUnassociatedContacts(this.params.data);
      }

    },
    acceptRemainderAccounts() {
      this.$parent.$parent.acceptRemainderAccounts(this.params.data);
    },
    rejectRemainderAccounts() {
      this.$parent.$parent.rejectRemainderAccounts(this.params.data);
    },
    rejectEnhancedAccounts() {
      this.$parent.$parent.rejectEnhancedAccounts(this.params.data);
    },
    goToContactEmailExistsView() {
      this.$parent.$parent.viewContactpopup(this.params.data);
      // let route = this.$router.resolve('/contacts/' + this.params.data.contact_id); // This also works.
      // window.open(route.href, '_blank');
    },
    goToContactEmailExistsEdit() {
      this.$parent.$parent.editContactpopup(this.params.data);
    },
    goToOpportunityFieldView() {
      // console.log(this.params.data);
      this.$router.push({
        path: "/fields/opportunity-field/" + this.params.data.opportunity_field_id
      });
    },
    goToOpportunityFieldEdit() {
      this.$router.push({
        path: "/fields/opportunity-field/edit/" + this.params.data.opportunity_field_id
      });
    },
    goToMasterFieldView() {
      // console.log(this.params.data);
      this.$router.push({
        path: "/fields/master-field/" + this.params.data.master_field_id
      });
    },
    goToMasterFieldEdit() {
      this.$router.push({
        path: "/fields/master-field/edit/" + this.params.data.master_field_id
      });
    },
    goToActionTypeOutcomeOptionDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Option`,
        accept: this.deleteActionTypeOutcomeOption,
        acceptText: "Delete"
      });
    },
    deleteActionTypeOutcomeOption() {

      this.$store
        .dispatch(
          "AuditTrialsManagement/removeActionTypeOutcomeOption",
          this.params.data.uuid
        )
        .then(res => {
          if (res.data.status == "success") {
            this.showActionTypeOutcomeOptionSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showActionTypeOutcomeOptionSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Option Deleted",
        text: "The option was successfully deleted"
      });
      this.params.api.refreshServerSide({purge:false});
    },
    goToMasterFieldDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Master Field`,
        accept: this.deleteMasterField,
        acceptText: "Delete"
      });
    },
    deleteMasterField() {
      this.$store
        .dispatch(
          "MasterFieldsManagement/removeMasterField",
          this.params.data.master_field_id
        )
        .then(res => {
          if (res.data.status == "success") {
            this.showMasterFieldDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showMasterFieldDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Master Field Deleted",
        text: "The master field was successfully deleted"
      });
      this.params.api.refreshServerSide({purge:false});
    },
    goToClientFieldView() {
      // console.log(this.params.data);
      this.$router.push({
        path: "/fields/client-field/" + this.params.data.client_field_id
      });
    },
    goToClientFieldEdit() {
      this.$router.push({
        path: "/fields/client-field/edit/" + this.params.data.client_field_id
      });
    },
    goToClientFieldDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Client Field`,
        accept: this.deleteClientField,
        acceptText: "Delete"
      });
    },
    deleteClientField() {
      this.$store
        .dispatch(
          "ClientFieldsManagement/removeClientField",
          this.params.data.client_field_id
        )
        .then(res => {
          if (res.data.status == "success") {
            this.showClientFieldDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showClientFieldDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Client Field Deleted",
        text: "The client field was successfully deleted"
      });
      this.params.api.refreshServerSide({purge:false});
    },
    goToCampaignFieldView() {
      // console.log(this.params.data);
      this.$router.push({
        path: "/fields/campaign-field/" + this.params.data.campaign_field_id
      });
    },
    goToCampaignFieldEdit() {
      this.$router.push({
        path: "/fields/campaign-field/edit/" + this.params.data.campaign_field_id
      });
    },
    goToCampaignFieldDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Campaign Field`,
        accept: this.deleteCampaignField,
        acceptText: "Delete"
      });
    },
    deleteCampaignField() {
      this.$store
        .dispatch(
          "CampaignFieldsManagement/removeCampaignField",
          this.params.data.campaign_field_id
        )
        .then(res => {
          if (res.data.status == "success") {
            this.showCampaignFieldDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showCampaignFieldDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Campaign Field Deleted",
        text: "The campaign field was successfully deleted"
      });
      this.params.api.refreshServerSide({purge:false});
    },
    goToContactView() {
      // console.log("contacc" , JSON.stringify(this.params.data))
      this.$router.push({ path: "contacts/view/" + this.params.data.contact_id + "/" + this.params.data.account_id });
    },
    goToContactEdit() {
      this.$router.push({ path: "contacts/edit/" + this.params.data.contact_id + "/" + this.params.data.account_id });

    },
    goToContactDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Contact`,
        accept: this.deleteContact,
        acceptText: "Delete"
      });
    },
    deleteContact() {
      this.$store
        .dispatch(
          "contactsManagement/removeContact",
          this.params.data.contact_id
        )
        .then(res => {
          if (res.data.status == "success") {
            this.showDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Contact Deleted",
        text: "The contact was successfully deleted"
      });
      this.params.api.refreshServerSide({purge:false});
    },
    associateContactToAccount() {
      this.params.data.action_type = "associateContactToAccount";
      this.$parent.$parent.showContactsPopUp(this.params.data);
      this.selected_account = this.params.data;
    },
    addNewContact() {
      this.$parent.$parent.addContactsPopUp(this.params.data);
    },
    showCampaignSelectedFields() {
      this.$parent.$parent.showCampaignSelectedFields(this.params.data);
    },
    showCampaignCascadedFields() {
      this.$parent.$parent.showCampaignCascadedFields(this.params.data);
    },
    openPopulateDataPopUp() {
      this.$parent.$parent.openPopulateDataPopUp(this.params.data);
    },
    validatePopulateDataPopUp() {
      this.$parent.$parent.validatePopulateDataPopUp(this.params.data);
    },
      goToHistoricSDDashboard() {
      this.$parent.$parent.goToHistoricSDDashboard(this.params.data);
    },
      goToLiveSDDashboard() {
      this.$parent.$parent.goToLiveSDDashboard(this.params.data);
    },
    goToLiveSalesDeveloperDefaultViews() {
      this.$parent.$parent.goToLiveSalesDeveloperDefaultViews(this.params.data);
    },
    goToEditSalesDeveloperOpportunities() {
      this.$parent.$parent.goToEditSalesDeveloperOpportunities(this.params.data);
    },
    goToViewClientOpportunities() {
      this.$parent.$parent.goToViewClientOpportunities(this.params.data);
    },
    goToViewAccount(){
  this.$router.replace({
   path: "/accounts/" + this.params.data.uuid
   });
 },
 goToEditAccount(){
  this.$router.replace({
   path: "/accounts/edit/" + this.params.data.uuid
   });
 },
 deleteAccount() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Account`,
        text: `You are about to delete "${this.params.data.company_name}"`,
        accept: this.deleteMainAccount,
        parameters: this.params.data.uuid,
        acceptText: "Delete"
      });
    },
    deleteMainAccount() {
      axios
        .post(
          this.$base_url + "/api/accounts/delete_account_grid",
          {
            account_id: this.params.data.uuid,
          }
        )
        .then(response => {
          if (response.data.status == "success") {
            this.showDeleteAccountSuccess();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    showDeleteAccountSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Account Deleted",
        text: "The account was successfully deleted"
      });
      this.params.api.refreshServerSide({purge:false});
    },
    editSalesDeveloperRecords() {


        // this.params.node.data.forename = 'Kabita'

        // this.params.api.refreshCells({ force: true });

        // console.log(this.params.node)


         if(this.params.data.acc_id){
                 this.$parent.$parent.editSalesDeveloperAccount(this.params);
         }else{
              this.$parent.$parent.editSalesDeveloperContact(this.params);
         }

            console.log(this.params.data)

            if(this.params.data.new_contact_id && this.params.data.account_id){
                  this.$parent.$parent.showContactsFieldsWithContactID(this.params.data.new_contact_id , this.params.data.account_id);

        }


    },
    viewClientUserRecords() {


      if(this.params.data.acc_id){
                 this.$parent.$parent.viewClientUserAccountRecords(this.params.data);
         }else{
              this.$parent.$parent.viewClientUserContactRecords(this.params.data);
         }
    },
    updateCampaignSelectedFields() {
      this.$parent.$parent.updateCampaignSelectedFields(this.params.data);
    },
    associateContactToSelectedAccountPopup() {
      this.params.data.action_type = "associateContactToSelectedAccountPopup";
      this.$parent.$parent.associateContactToSelectedAccountPopup(
        this.params.data
      );
      this.selected_account = this.params.data;
    },
    deleteSelectedAccountForCampaign() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Account`,
        text: `You are about to delete "${this.params.data.company_name}"`,
        accept: this.deleteSelectedAccount,
        parameters: this.params.data.account_id,
        acceptText: "Delete"
      });
    },
    deleteSelectedAccount(campaign_account_id) {
      axios
        .post(
          this.$base_url + "/api/accounts/delete_selected_accounts_for_campaign",
          {
            campaignId: this.$route.params.campaignId,
            campaign_account_id: campaign_account_id
          }
        )
        .then(response => {
          if (response.data.status == "success") {
            this.showDeleteSelectedAccountSuccess();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    showDeleteSelectedAccountSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Account Deleted",
        text: "The account was successfully deleted"
      });
      this.params.api.refreshServerSide({purge:false});
    },
    goToCoreFieldView() {
      // console.log(this.params.data);
      this.$router.push({
        path: "/fields/core-field/" + this.params.data.core_field_id
      });
    },
    goToCoreFieldEdit() {
      this.$router.push({
        path: "/fields/core-field/edit/" + this.params.data.core_field_id
      });
    },

    goToCoreFieldDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Core Field`,
        accept: this.deleteCoreField,
        acceptText: "Delete"
      });
    },
    deleteCoreField() {
      this.$store
        .dispatch(
          "CoreFieldsManagement/removeCoreField",
          this.params.data.core_field_id
        )
        .then(res => {
          if (res.data.status == "success") {
            this.showCoreFieldDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showCoreFieldDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Core Field Deleted",
        text: "The core field was successfully deleted"
      });
      this.params.api.refreshServerSide({purge:false});
    },
  },
  beforeMount() {},
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });


 
  }
};
</script>
